export default __webpack_public_path__ + "static/media/default-preview-image.0db7a541.png";